module.exports = __webpack_public_path__ + "static/background-image-l-6a8618bd15031c424834891c83c008fb.mp4";